import React from "react";
import { Container, Spinner, Row, Col, Breadcrumb } from 'react-bootstrap';
import { Link } from "react-router-dom";
import ExchangeSummaryTable from './components/ExchangeSummaryTable'
import NotFound from "./components/NotFound";
import { ReactComponent as LinkIcon } from './components/svg/link-45deg.svg';
import exchangelogo from "./components/logos/exchangelogo.svg";

class ExchangeSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      exchange: []
    };
  }

  componentDidMount() {
    this.getSupportedExchanges();
    this.getSummary();
    this.timer = setInterval(() => (this.getSummary()), 15000);
    document.title = this.props.match.params.exchange + " - Dados de volume e preço das criptomoedas negociadas em real brasileiro na corretora · MercadoCripto"
  }

  getSupportedExchanges() {
    var propsexchange = this.props.match.params.exchange
    fetch(process.env.REACT_APP_API_URL + "/v1/exchanges/")
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            supported_exchanges: result.filter(function (entry) {
              return entry.Name === propsexchange
            })[0]
          })
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }

  getSummary() {
    fetch(process.env.REACT_APP_API_URL + "/v1/ticker/exchanges/" + this.props.match.params.exchange)
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            exchange: result
          })
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      );
    Array.from(document.getElementsByClassName('toupdate')).forEach((el) => el.classList.add('updated'));
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.exchange !== prevProps.match.params.exchange) {
      this.setState({
        isLoaded: false,
      })
      this.getSummary();
    }
    else { }
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
    clearInterval(this.timer);
  }

  render() {
    const { error, isLoaded, exchange, supported_exchanges } = this.state;
    if (error) {
      return <Container className="py-3"><h5 className="mt-5 pt-5 text-center text-muted">Erro no servidor. Volte mais tarde.</h5> {console.log(error.message)}</Container>;
    } else if (!isLoaded) {
      return <Container className="text-center p-5"><br /><Spinner variant="primary" className="m-5" animation="border" role="status"><span className="visually-hidden">Carregando...</span></Spinner></Container>;
    } else if (!supported_exchanges) {
      return (<><NotFound /></>)
    } else {
      return (
        <>
          <div className="bg-light border-bottom pb-3">
            <Container>
              <Breadcrumb  className="pt-2">
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/corretoras" }}>
                  Corretoras
                </Breadcrumb.Item>
                <Breadcrumb.Item active>{this.props.match.params.exchange}</Breadcrumb.Item>
              </Breadcrumb>
              <div className="mx-auto text-center py-2 rounded mb-2 d-none d-sm-block" alt="Ad" style={{ width: "72vw", height: "9vw", maxWidth: "728px", maxHeight: "90px", background: "linear-gradient(10deg,rgb(54, 96, 153) 0%,rgb(93 166 227) 100%)" }}><Link to="contato" className="text-decoration-none text-white h2">Anuncie aqui</Link></div>
              <div className="mx-auto text-center py-2 rounded mb-2 d-sm-none d-block" alt="Ad" style={{ width: "100%", height: "45vw", background: "linear-gradient(10deg,rgb(54, 96, 153) 0%,rgb(93 166 227) 100%)" }}><Link to="contato" className="text-decoration-none text-white h2">Anuncie aqui</Link></div>
              <h1 className="h2 text-center text-md-left">
                <svg className="exchangelogo mr-2" role="img" aria-labelledby="title">
                  <title id="title">{this.props.match.params.exchange}</title>
                  <use href={exchangelogo + "#" + (this.props.match.params.exchange.toLowerCase())}></use>
                </svg>
                <span className="align-middle mx-2">{this.props.match.params.exchange}</span>
              </h1>
              <div className="pt-2 pl-2 text-muted  text-center text-md-left">{supported_exchanges.URL !== null ? <LinkIcon /> : ""}<a href={supported_exchanges.URL !== undefined ? supported_exchanges.URL : "#"} rel="nofollow noopener noreferrer" target="_blank" className="text-muted pl-1">{supported_exchanges.URL !== undefined ? supported_exchanges.URL : "#"}</a></div>
              <Row className="pt-3 text-center">
                <Col md={4}>
                  <h2 className="h6 text-muted">Volume nos pares BRL (24h)</h2>
                  <span className="h5">{exchange.reduce((a, e) => a + e.QuoteVolume, 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                </Col>
                <Col md={4} className="text-center mt-2">
                  <h3 className="h6 text-muted">Criptomoedas negociadas em BRL</h3>
                  <span className="h5">{exchange.length}</span>
                </Col>
              </Row>
            </Container>
          </div>
          <Container>
            <ExchangeSummaryTable data={exchange} />
          </Container>
        </>
      );
    }
  }
}
export default ExchangeSummary;